import { render, staticRenderFns } from "./dormitoryDetail.vue?vue&type=template&id=aba0642c&"
import script from "./dormitoryDetail.vue?vue&type=script&lang=js&"
export * from "./dormitoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports